export default __webpack_public_path__ + "atomic/_patterns/03-organisms/related-items-block/_related-items-block.twig";